import { z } from 'zod';

export const mapRegionSchema = z.object({
  mapsetId: z.number(),
  mapsetName: z.string(),
});

export const mapRegionsSchema = z.array(mapRegionSchema);

export type MapRegion = z.infer<typeof mapRegionSchema>;

export type MapRegions = z.infer<typeof mapRegionsSchema>;
